import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import RichTextConverter from './RichText/RichTextConverter';
import * as styles from './SimpleCard.module.css';

const SimpleCard = ({
  imageSrc,
  imageObj,
  imageType = 'icon',
  title,
  body,
  bodyText,
  center = false,
  short = false,
  ...rest
}) => {
  return (
    <div className={styles.container} {...rest}>
      {imageSrc && (
        <div
          className={[
            imageType === 'full' ? styles.full : '',
            center ? styles.center : '',
            short ? styles.short : '',
          ].join(' ')}
        >
          <img src={imageSrc} alt={title} loading="lazy" className={imageType === 'icon' ? styles.icon : ''} />
        </div>
      )}
      {!imageSrc && imageObj && (
        <div
          className={[
            imageType === 'full' ? styles.full : '',
            center ? styles.center : '',
            short ? styles.short : '',
          ].join(' ')}
        >
          <GatsbyImage
            data-ot-ignore
            alt={title}
            image={imageObj}
            className={imageType === 'icon' ? styles.icon : ''}
            loading={'lazy'}
          />
        </div>
      )}
      <h4>{title}</h4>
      {body && (
        <div className={styles.content}>
          <RichTextConverter copy={body} />
        </div>
      )}
      {bodyText && <div className={styles.content}>{bodyText}</div>}
    </div>
  );
};

SimpleCard.propTypes = {
  /**
   * Image source url
   */
  imageSrc: PropTypes.string,
  /**
   * Gatsby Image object
   */
  imageObj: PropTypes.object,
  /**
   * Display type of image being icon or full width of card
   */
  imageType: PropTypes.oneOf(['icon', 'full']),
  /**
   * the heading for the card
   */
  title: PropTypes.string,
  /**
   * Provide rich text raw json if using the contentful RTE
   */
  bodyRawJson: PropTypes.string,
  /**
   * Provide the
   */
  bodyText: PropTypes.string,
};

export default SimpleCard;
